module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "手动登记出勤",
      "width": "520",
      "mask-closable": false,
      "transfer": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师 ID",
      "required": ""
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "在职外教 ID"
    },
    model: {
      value: (_vm.form.tchId),
      callback: function($$v) {
        _vm.$set(_vm.form, "tchId", $$v)
      },
      expression: "form.tchId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "日期",
      "required": ""
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "date",
      "value": _vm.form.date,
      "clearable": false,
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.form.date = $event
      }
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "类型",
      "required": ""
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": 1000,
      "placeholder": "可空，最长 1000 字"
    },
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("登记")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-063c4a4c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrWorkbench/modal/FollowupManualModal.vue
// module id = 1619
// module chunks = 8